<template>
  <div v-if="layout === 'vertical'" class="book-card"
    :class="{'book-card--mobile': deviceType === 'mobile'}" @click="$emit('click')">
    <div class="book-card__image-container">
      <img :src="book.coverImage" :alt="book.title" class="book-card__cover">
    </div>
    <div class="book-card__content">
      <div class="book-card__title">{{ book.title }}</div>
      <svg class="book-card__next-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
        viewBox="0 0 20 20" fill="none">
        <path
          d="M20 10C20 4.47691 15.5301 0 10.0158 0C5.36501 0 1.1105 3.18906 0 7.5H8.76781L8.73615 5L16.2243 10L8.73615 15L8.76781 12.5H0C1.1091 16.8103 5.36501 20 10.0158 20C15.5301 20 20 15.5224 20 10Z"
          fill="#000" />
      </svg>
    </div>
  </div>
  <div v-else-if="layout === 'horizontal'" class="book-card-horizontal" @click="$emit('click')">
    <div class="book-card-horizontal__overlay-gradient"></div>
    <div class="book-card-horizontal__content">
      <div class="book-card-horizontal__info">
        <div class="book-card-horizontal__info-top">
          <div class="book-card-horizontal__title">{{ book.title }}</div>
          <div class="book-card-horizontal__author">By {{ book.author }}</div>
        </div>
        <div class="book-card-horizontal__info-bottom">
          <div class="book-card-horizontal__tag book-card-horizontal__tag--rating">
            <img src="@/assets/star.svg" alt="star" class="book-card-horizontal__star-icon">
            <span>{{ book.rating }}</span>
          </div>
          <div class="book-card-horizontal__tag">{{ book.category }}</div>
        </div>
      </div>
      <img :src="book.coverImage" :alt="book.title" class="book-card-horizontal__cover">
    </div>
  </div>
  <div v-else-if="layout === 'cover-hover'" class="book-card-cover-hover" @click="$emit('click')">
    <img :src="book.coverImage" :alt="book.title" class="book-card-cover-hover__cover" />
    <div class="book-card-cover-hover__overlay">
      <div class="book-card-cover-hover__overlay-content">
        <div class="book-card-cover-hover__info">
          <div class="book-card-cover-hover__tag book-card-cover-hover__tag--rating"
            v-if="book.rating">
            <img src="@/assets/star.svg" alt="star" />
            <span>{{ book.rating }}</span>
          </div>
          <div class="book-card-cover-hover__title">{{ book.title }}</div>
          <div class="book-card-cover-hover__author" v-if="book.author">By {{ book.author }}</div>
        </div>
        <div class="book-card-cover-hover__tags">
          <div class="book-card-cover-hover__tag" v-if="book.category">{{ book.category }}</div>

        </div>
      </div>
    </div>
  </div>
  <div v-else-if="layout === 'recent'" class="book-card-recent" @click="$emit('click')">
    <div class="book-card-recent__info">
      <div class="book-card-recent__title">{{ book.title }}</div>
      <div class="book-card-recent__author">By {{ book.author }}</div>
    </div>
    <img :src="book.coverImage" :alt="book.title" class="book-card-recent__cover">
  </div>
  <div v-else-if="layout === 'rank'" class="book-card-rank" @click="$emit('click')">
    <img :src="book.coverImage" :alt="book.title" class="book-card-rank__cover">
    <div class="book-card-rank__badge" v-if="book.rank && book.rank <= 3">
      <span>Top {{ book.rank }}</span>
    </div>
    <div class="book-card-rank__overlay">
      <div class="book-card-rank__title">{{ book.title }}</div>
    </div>
  </div>
  <div v-else-if="layout === 'editor-choice'" class="book-card-editor-choice"
    @click="$emit('click')">
    <div class="book-card-editor-choice__image-container">
      <div class="book-card-editor-choice__image-wrapper">
        <img :src="book.coverImage" :alt="book.title" class="book-card-editor-choice__cover" />
      </div>
      <div class="book-card-editor-choice__tag-overlay">
        <div class="book-card-editor-choice__category-badge">
          <img src="@/assets/category/all.svg" alt="icon"
            class="book-card-editor-choice__category-icon">
          <span>{{ book.category || 'Fiction' }}</span>
        </div>
      </div>
    </div>

    <div class="book-card-editor-choice__info">
      <div class="book-card-editor-choice__title">{{ book.title }}</div>
      <div class="book-card-editor-choice__author">{{ book.author }}</div>
    </div>

    <div class="book-card-editor-choice__stats">
      <div class="book-card-editor-choice__stat-item">
        <img src="@/assets/star.svg" alt="rating" class="book-card-editor-choice__stat-icon">
        <div class="book-card-editor-choice__stat-text">{{ book.rating || 'N/A' }}</div>
      </div>
      <div class="book-card-editor-choice__stat-item">
        <img src="@/assets/readiness_score.svg" alt="type"
          class="book-card-editor-choice__stat-icon">
        <div class="book-card-editor-choice__stat-text">Novel</div>
      </div>
      <div class="book-card-editor-choice__stat-item">
        <img src="@/assets/view-all.svg" alt="view" class="book-card-editor-choice__stat-icon">
        <div class="book-card-editor-choice__stat-text">Read</div>
      </div>
    </div>

    <div class="book-card-editor-choice__footer">
      <div class="book-card-editor-choice__price">Free</div>
      <img src="@/assets/arrow_outward.svg" alt="go" class="book-card-editor-choice__go-icon">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BookCard',
  props: {
    book: {
      type: Object,
      required: true,
    },
    layout: {
      type: String,
      default: 'vertical', // 'vertical' or 'horizontal'
    },
  },
  computed: {
    ...mapGetters(['deviceType']),
    horizontalCardStyle () {
      if (this.layout === 'horizontal' && this.book.coverImage) {
        return {
          backgroundImage: `url(${this.book.coverImage})`,
        };
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.book-card {
	width: rem(196);
	border-radius: rem(12);
	overflow: hidden;
	position: relative;
	cursor: pointer;
	background: #fff;
	transition: transform 0.3s ease-in-out;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: rem(8);
	box-sizing: border-box;

	&:hover {
		transform: translateY(-4px);
		.book-card__next-icon {
			path {
				fill: #0088ff;
			}
		}
	}

	&__image-container {
		width: 100%;
		aspect-ratio: 180/270;
		border-radius: rem(12);
		overflow: hidden;
		border: 1px solid rgba(0, 0, 0, 0.1);
	}

	&__cover {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__content {
		padding: rem(12) rem(8) rem(8);
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: flex-end;
		justify-content: space-between;
	}

	&__title {
		font-size: rem(16);
		font-weight: 500;
		line-height: rem(20);
		color: #000;
		flex: 1;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__next-icon {
		width: rem(20);
		height: rem(20);
		flex-shrink: 0;
	}
}

// Styles for the new horizontal layout
.book-card-horizontal {
	position: relative;
	width: rem(344);
	// height: rem(180);
	border-radius: rem(12);
	overflow: hidden;
	cursor: pointer;
	transition: transform 0.3s ease;
	background: linear-gradient(180deg, #0088ff 0%, #0088ff 20%, rgba(0, 136, 255, 0) 100%);
	box-sizing: border-box;

	&:hover {
		transform: translateY(-4px);
	}

	&__content {
		position: relative;
		z-index: 2;
		display: flex;
		// align-items: flex-start;
		align-items: stretch;
		justify-content: space-between;
		height: max-content;
		padding: rem(16);
		gap: rem(16);
		box-sizing: border-box;
	}

	&__cover {
		width: rem(120);
		height: rem(180);
		border-radius: rem(12);
		object-fit: cover;
		box-shadow: 0 rem(4) rem(8) rgba(0, 0, 0, 0.1);
		border: 1px solid rgba(0, 0, 0, 0.1);
		flex-shrink: 0;
		margin-top: rem(-16); // To make it align with top of padding? No, Figma shows it inside.
		// Wait, Figma shows padding 16px and image height 180px, card height 180px.
		// This means image is actually taller than the card's inner height if padding is 16px.
		// Let's adjust height or remove padding for image.
		height: 100%;
		margin: 0;
	}

	&__info {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		// height: -webkit-fill-available;
		flex: 1;
		color: #fff;
		gap: rem(24);
		// overflow: hidden;
		padding: rem(4) rem(4) 0;
	}

	&__info-top {
		display: flex;
		flex-direction: column;
		gap: rem(12);
	}

	&__title {
		font-size: rem(20);
		font-weight: 700;
		line-height: rem(24);
		color: #fff;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__author {
		font-size: rem(12);
		line-height: rem(12);
		font-style: italic;
		color: #fff;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__info-bottom {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
	}

	&__tag {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 0 rem(12);
		height: rem(24);
		border-radius: rem(100);
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		background: #fff;
		color: #000;
		border: 1px solid #fff;
		box-sizing: border-box;

		&--rating {
			gap: rem(4);
			font-weight: 600;
			font-size: rem(13);
			line-height: rem(14);
			padding: rem(8) rem(12);
			height: rem(24);

			.book-card-horizontal__star-icon {
				width: rem(12);
				height: rem(12);
			}
		}
	}
}

.book-card-cover-hover {
	position: relative;
	// width: rem(160);
	height: rem(240);
	border-radius: rem(12);
	overflow: hidden;
	cursor: pointer;
	transition: transform 0.3s ease;
	box-shadow: 0px 4px 8px 0px rgba(22, 19, 80, 0.28);
	flex: 0 0 calc((100% - rem(120)) / 6); /* 使每个子元素占1/3的宽度 */

	&:hover {
		transform: translateY(-4px);
		.book-card-cover-hover__overlay {
			opacity: 1;
		}
	}

	&__cover {
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: transform 0.3s ease;
	}

	&__overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
		transition: opacity 0.3s ease;
		background: linear-gradient(180deg, rgba(22, 19, 80, 0.9) 0%, rgba(22, 19, 80, 0.3) 100%);
		backdrop-filter: blur(4px);
		color: #fff;
	}

	&__overlay-content {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: rem(20) rem(16);
		height: 100%;
		box-sizing: border-box;
	}

	&__info {
		display: flex;
		flex-direction: column;
		gap: rem(16);
	}

	&__title {
		font-size: rem(18);
		font-weight: 900;
		line-height: 1.2;
		display: -webkit-box;
		-webkit-line-clamp: 4;
		line-clamp: 4;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__author {
		font-size: rem(12);
		white-space: nowrap;
		overflow: hidden;
		display: -webkit-box;
		text-overflow: ellipsis;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}

	&__tags {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
	}

	&__tag {
		display: inline-flex;
		align-items: center;
		gap: rem(8);
		border-radius: rem(8);
		font-size: rem(13);
		font-weight: 700;
		border: 1px solid #fff;

		display: flex;
		height: rem(24);
		padding: 0 rem(12);
		justify-content: center;
		align-items: center;
		flex-shrink: 0;

		border-radius: rem(100);
		border: rem(1) solid #fff;

		&--rating {
			border-radius: rem(30);
			background: #fff;
			display: flex;
			height: rem(24);
			padding: 0 rem(12);
			justify-content: center;
			align-items: center;
			gap: rem(4);
			width: fit-content;
			color: #000;
			font-size: rem(13);
			font-style: normal;
			font-weight: 600;
			line-height: rem(14); /* 107.692% */
			display: flex;
			align-items: center;
			img {
				width: rem(12);
				height: rem(12);
			}
		}
	}
}

.book-card-recent {
	background: linear-gradient(180deg, #0088ff 0%, #0088ff 20%, rgba(0, 136, 255, 0) 100%);
	border-radius: rem(12);
	padding: rem(8);
	display: flex;
	flex-direction: column;
	gap: 0;
	align-items: center;
	justify-content: flex-start;
	flex-shrink: 0;
	width: rem(160);
	position: relative;
	cursor: pointer;
	transition: transform 0.3s ease;

	&:hover {
		transform: translateY(-4px);
	}

	&__info {
		padding: rem(4) rem(4) rem(10);
		display: flex;
		flex-direction: column;
		gap: rem(6);
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
	}

	&__title {
		color: #fff;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 700;
		align-self: stretch;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__author {
		color: #fff;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		font-style: italic;
		align-self: stretch;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	&__cover {
		border-radius: rem(12);
		border: 1px solid rgba(0, 0, 0, 0.1);
		align-self: stretch;
		height: rem(216);
		object-fit: cover;
	}
}

.book-card-rank {
	width: rem(86);
	height: rem(130);
	position: relative;
	border-radius: rem(12);
	overflow: hidden;
	cursor: pointer;
	transition: transform 0.3s ease;
	border: 1px solid rgba(0, 0, 0, 0.1);

	&:hover {
		transform: translateY(-2px);
		.book-card-rank__overlay {
			opacity: 1;
		}
	}

	&__cover {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__badge {
		background: #0088ff;
		border-radius: 0 rem(12) 0 rem(12);
		padding: rem(6) rem(12);
		display: flex;
		align-items: center;
		justify-content: center;
		height: rem(20);
		position: absolute;
		left: 0;
		bottom: 0;
		z-index: 2;

		span {
			color: #fff;
			font-size: rem(12);
			line-height: rem(12);
			font-weight: 700;
			white-space: nowrap;
		}
	}

	&__overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 136, 255, 0.5);
		backdrop-filter: blur(6px);
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		padding: rem(12) rem(10);
		box-sizing: border-box;
		opacity: 0;
		transition: opacity 0.3s ease;
		z-index: 1;
	}

	&__title {
		color: #fff;
		font-size: rem(14);
		line-height: rem(16);
		font-weight: 700;
		display: -webkit-box;
		-webkit-line-clamp: 6;
		line-clamp: 6;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		word-wrap: break-word;
	}
}

.detect_deviece_mobile {
	.book-card {
		width: rem(160);
		&__image-container {
			aspect-ratio: 160/240;
		}
	}
	.book-card-horizontal {
		width: 100%;
		min-height: rem(180);

		&__content {
			padding: rem(12);
		}
		&__cover {
			width: rem(100);
			height: rem(150);
		}
	}
}

.book-card-editor-choice {
	position: relative;
	width: rem(344);
	background: linear-gradient(180deg, rgba(226, 55, 45, 0) 0%, rgba(226, 55, 45, 0.2) 100%);
	border: 1px solid rgba(255, 255, 255, 0.2);
	border-radius: rem(16);
	box-shadow: 0 rem(4) rem(12) 0 rgba(0, 0, 0, 0.24);
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	overflow: hidden;
	box-sizing: border-box;
	cursor: pointer;
	transition: transform 0.3s ease;
	background-color: #2b2b2b; // Fallback dark

	&:hover {
		transform: translateY(-4px);
	}

	&__image-container {
		width: 100%;
		height: rem(200);
		position: relative;
		padding: rem(8);
		display: flex;
		justify-content: center;
		align-items: center;
		flex-shrink: 0;
	}

	&__image-wrapper {
		width: rem(328);
		height: rem(184);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.2);
		box-shadow: 0 rem(4) rem(12) 0 rgba(0, 0, 0, 0.24);
		overflow: hidden;
		position: relative;
	}

	&__cover {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__tag-overlay {
		position: absolute;
		top: rem(8);
		left: rem(8);
		display: flex;
		align-items: flex-start;
	}

	&__category-badge {
		display: flex;
		align-items: center;
		background: #e2372d;
		padding: rem(6) rem(8);
		gap: rem(4);
		border-radius: rem(16) 0 rem(12) 0;
		box-shadow: rem(4) rem(4) rem(12) 0 rgba(0, 0, 0, 0.32);

		span {
			color: #fff;
			font-size: rem(12);
			line-height: rem(12);
			font-weight: 400;
			text-transform: capitalize;
		}
	}

	&__category-icon {
		width: rem(14);
		height: rem(14);
		filter: brightness(0) invert(1);
	}

	&__info {
		padding: rem(12) rem(20) rem(20);
		width: 100%;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		gap: rem(12);
	}

	&__title {
		font-size: rem(20);
		font-weight: 800;
		line-height: rem(24);
		color: #fff;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
		white-space: normal;
	}

	&__author {
		font-size: rem(12);
		font-weight: 400;
		line-height: rem(12);
		color: #fff;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		line-clamp: 1;
		-webkit-box-orient: vertical;
		white-space: normal;
	}

	&__stats {
		display: flex;
		gap: rem(8);
		padding: 0 rem(16);
		width: 100%;
		box-sizing: border-box;
	}

	&__stat-item {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: rem(12);
		padding: rem(12);
		border-radius: rem(12);
		border: 1px solid rgba(255, 255, 255, 0.1);
		background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.1) 100%);
	}

	&__stat-icon {
		width: rem(20);
		height: rem(20);
		filter: brightness(0) invert(1);
	}

	&__stat-text {
		font-size: rem(12);
		font-weight: 500;
		line-height: rem(12);
		color: #fff;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
	}

	&__footer {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: rem(24) rem(20);
		width: 100%;
		box-sizing: border-box;
	}

	&__price {
		font-size: rem(16);
		font-weight: 800;
		color: #e2372d;
	}

	&__go-icon {
		width: rem(24);
		height: rem(24);
		filter: brightness(0) invert(1);
	}
}

.detect_deviece_mobile {
	.book-card-editor-choice {
		width: rem(300);
	}
}
</style> 